import { TextareaAutosize } from '@material-ui/core';
import React, { useState } from 'react';
import { useForms } from '../../../../hooks/forms';
import PropTypes from 'prop-types';
import { hasErrors } from '../../../../helpers';
import './TextAreaAutosizeWidget.css';

const TextAreaAutosizeWidget = ({ widgetProps, onChange, isSubItem = false, textKey }) => {
    const { isJourney, isReadOnly, errors } = useForms();
    const displayingValue = textKey ? widgetProps[textKey] : widgetProps.value;
    const withErrors = hasErrors(widgetProps.id, errors);

    const [focused, setFocused] = useState(false);
    const isActive = focused || !!displayingValue;

    const labelText = isSubItem ? widgetProps.textTitle : widgetProps.title;

    return (
        <div className="floating-textarea-wrapper">
            <label
                htmlFor={widgetProps.id}
                className={`floating-label ${isActive ? 'active' : ''} ${withErrors ? 'error' : ''}`}
            >
                {labelText}
                {!isSubItem && widgetProps.isRequired && ' *'}
            </label>
            <TextareaAutosize
                id={widgetProps.id}
                className={`floating-textarea usePlaceholderTextField usePlaceholderTextArea ${
                    withErrors && !isReadOnly ? 'errorPlaceholder' : 'transparentPlaceholder'
                }`}
                required={!isSubItem && widgetProps.isRequired}
                value={displayingValue || ''}
                disabled={!isJourney || isReadOnly}
                onChange={({ target }) => {
                    const newValue = target.value || '';
                    onChange(widgetProps.id, newValue);
                }}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
            />
        </div>
    );
};

TextAreaAutosizeWidget.propTypes = {
    onChange: PropTypes.func.isRequired,
    isSubItem: PropTypes.bool,
    textKey: PropTypes.string,
    widgetProps: PropTypes.object.isRequired
};

export default TextAreaAutosizeWidget;
